<template>
  <div>
    <div @click="openModal">
      <img v-if="payload.status == undefined || payload.status.name == undefined" class="btn" src="/edit_icon.svg" width="24px">
      <a v-else class="status_color_text" :class="buttonClass" :style="{ 'background-color': getStatusColor() }" >{{ statusLabel }}</a>
    </div>
    <!-- R1.1 - manual-intake review: reason chip + continue / retry (reject stays in the status form) -->
    <IntakeReviewActions v-if="isIntakeReview" :offer="payload" @resolved="onIntakeResolved" />
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import IntakeReviewActions from '@/components/IntakeReviewActions'
import { INTAKE_REVIEW_STATUS, offerStatusLabel } from '@/custom/classes/offer_status_labels'
export default {
  name: 'offer-status',
  components: { IntakeReviewActions },
  props: {
    payload: {
      type: Object
    },
    buttonClass: {
      type: String
    }
  },
  computed: {
    statusName () {
      return this.payload && this.payload.status ? this.payload.status.name : undefined
    },
    statusLabel () {
      return offerStatusLabel(this.statusName)
    },
    isIntakeReview () {
      return this.statusName === INTAKE_REVIEW_STATUS
    },
    ...mapGetters('offerStatuses', ['getOrangeList', 'getGreenList', 'getPurpleList', 'getRedList', 'getDarkRedList'])
  },
  methods: {
    openModal () {
      this.create({ designator: 'offer-status-modal', component_name: 'OfferStatusForm', offer_data: this.payload, modal_title: 'Change Offer Status' })
    },
    getStatusColor () {
      if (this.payload.status == undefined) {
        return ''
      }
      let status = this.payload.status.name
      if (this.getGreenList.map(s => s.name).includes(status)) {
        return 'green'
      }
      if (this.getOrangeList.map(s => s.name).includes(status)) {
        return 'darkorange'
      }
      if (this.getPurpleList.map(s => s.name).includes(status)) {
        return 'purple'
      }
      if (this.getRedList.map(s => s.name).includes(status)) {
        return 'red'
      }
      if (this.getDarkRedList.map(s => s.name).includes(status)) {
        return 'saddlebrown'
      }
      return 'saddlebrown'
    },
    // Patch the row in place with the server's new status (the payload is the
    // parent's own offer object - DataTable rows and the bubble's offer), so it
    // stops showing as "ממתין לבדיקת יועצת"; then tell whoever listens.
    onIntakeResolved (event) {
      if (event.status && event.status !== this.statusName) {
        const status = this.payload.status && typeof this.payload.status === 'object' ? this.payload.status : {}
        this.$set(this.payload, 'status', { ...status, name: event.status })
      }
      this.$emit('resolved', event)
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
